import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SettingsService } from '@shared/api/settings.service';
import { BreakpointTypeEnum } from '@shared/types/screen-breakpoints';

@Component({
  selector: 'app-no-found',
  templateUrl: './no-found.component.html',
  styleUrls: ['./no-found.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NoFoundComponent {
  public readonly BreakpointTypeEnum = BreakpointTypeEnum;

  constructor(public settingsService: SettingsService) {}

  public toMain(): void {
    location.replace('/');
  }
}
